<template>
    <div class="container">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="90">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem
                        prop="houseId"
                        label="房源名称"
                        :viewonly="isView"
                    >
                        <form-lookup
                            v-model="info.houseId"
                            :options.sync="roomList"
                            placeholder="请选择房号"
                            title="选择房间"
                            textSymbol="title"
                            valueSymbol="id"
                            :modalHeight="600"
                            :modalWidth="900"
                            @clear="clear"
                            @deselect="clear"
                        >
                            <select-room
                                houseStatus="3"
                                :allowCheckParent="false"
                                showDetail
                            />
                        </form-lookup>
                    </FormItem>
                </Col>
                <!-- 新增 或者 查看且账期存在 才显示账期 -->
                <Col span="12" v-if="!isView || (isView && info.period)">
                    <FormItem label="账期" prop="period" :viewonly="isView">
                        <Select v-model="info.period" transfer placeholder="">
                            <Option
                                v-for="item in periodList"
                                :value="item.period"
                                :key="item.period"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Spin size="large" fix v-if="loading" />
            <receipt-bill
                v-else
                id="receipt"
                ref="receipt"
                :info="info"
                :showName="showName"
                :viewOnly="isView"
                :payTypeList="dict.payType.toList()"
            ></receipt-bill>
        </Form>
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
// prettier-ignore
import { upDigit, ymd, ymdL, cent, yuan, toDate, debounce, deepCopy } from '_u/helper'
import Dict from '_u/dict'
import { multiply } from '@/views/common/u-contract'

import SelectRoom from '_vc/select-room'
import ReceiptBill from './receipt-bill'

import { fileUpload } from '@/api/sys-oss'
import { queryPeriods } from '@/api/bill'
import {
    queryReceivedBill,
    fReceiptUpdate,
    fReceiptAdd,
    fReceiptView,
} from '@/api/receipt'

export default {
    name: 'RReceiptForm',
    inject: {
        $modal: {
            default: null,
        },
    },
    components: { SelectRoom, ReceiptBill },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        actionType: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            loading: true,
            dict: {
                payType: Dict.NULL,
                feeType: Dict.NULL,
            },
            info: {
                id: this.id, // 收据id
                houseId: '', // 房间id
                contractId: '', // 合同id
                receiptNo: '', // 收据号
                comName: '', // 公司名称
                cusMobile: '', // 客户手机号
                cusName: '', // 客户名称
                houseName: '', // 房源名称
                houseNo: '', // 房间代码
                houseNum: '', // 房号
                period: '', //账期
                totalAmount: '', // 合计金额
                amount: '300', // 实收金额
                payee: '', // 收款人
                payMethod: '', // 收款方式
                invoiceTime: '', // 开票时间
                periodCn: '', // 账期中文
                detailList: [], // 明细数据
                attachments: '',
                remark: '',
                ver: '',
            },
            roomList: [], // 房间列表
            periodList: [], // 账期列表
            totalAmountText: '', // 金额大写
            buildArea: '', // 建筑面积
            isView: this.actionType === '2' ? true : false,
            showName: '客户名称',
        }
    },
    watch: {
        // 切换房间
        roomList(el) {
            let house = el[0] || { id: '', contractId: '' }

            Object.assign(this.info, {
                houseId: house.id,
                contractId: house.contractId,
            })
        },
    },
    computed: {
        ruleValidate() {
            return this.isView
                ? {}
                : {
                      houseId: [{ required: true, message: '房源名称必填' }],
                      period: [{ required: true, message: '账期必填' }],
                  }
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.actionType === '1' || this.actionType === '3') {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        }

        // 打印
        btns.unshift({
            type: 'primary',
            name: 'print',
            text: '打印',
        })

        this.$modal.updateBtns(btns)
        this.$modal.beforeEnter((next) => {
            Promise.all([Dict.get(['pay_type', 'fee_type']), this.fetch()])
                .then((args) => {
                    var [dictGroup, view] = args
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    // 查看
                    if (view) {
                        const viewData = view.data.entity
                        const detailList = view.data.detailList

                        detailList.forEach((v) => {
                            v.amount = yuan(v.amount)
                        })

                        viewData.amount = yuan(viewData.amount)
                        viewData.totalAmount = yuan(viewData.totalAmount)

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                        this.info.detailList = detailList
                        this.info.remark = detailList[0]?.remark || ''
                        if (
                            (this.info.cusType && this.info.cusType === '2') ||
                            this.info.comName
                        ) {
                            this.showName = '单位名称'
                        }
                        this.info.invoiceTime = ymdL(this.info.invoiceTime)
                        this.totalAmountText = upDigit(this.info.totalAmount)
                        this.roomList = [
                            {
                                id: this.info.houseId,
                                title: this.info.houseName,
                                contractId: this.info.contractId,
                            },
                        ]
                        this.getPeriodsByContractId(this.info.contractId)
                    } else {
                        this.info.invoiceTime = ymdL(new Date())
                    }
                    this.$watch('info.houseId', function (val) {
                        if (val) {
                            // 得到房间相关数据
                            const house = this.roomList[0]

                            this.getPeriodsByContractId(house.contractId)

                            this.info.houseName = house.title
                            this.info.houseNo = house.houseNo
                            this.info.houseNum = `${house.floorName}${house.houseNum}`
                            this.info.cusName = house.cusName
                            this.info.cusType = house.cusType
                            this.info.comName = house.comName
                            this.buildArea = house.buildArea

                            if (
                                this.info.cusType &&
                                this.info.cusType === '2'
                            ) {
                                this.showName = '单位名称'
                            }
                        } else {
                            this.info.period = ''
                            this.info.houseName = ''
                            this.info.houseNo = ''
                            this.info.houseNum = ''
                            this.info.cusName = ''
                            this.info.contractId = ''
                            this.buildArea = ''
                        }

                        this.fetchBillList()
                    })
                    this.$watch('info.period', function (val) {
                        this.info.periodCn = val
                            ? this.periodList[val - 1]?.text
                            : ''
                        this.fetchBillList()
                    })
                    this.$watch('info.totalAmount', function (val) {
                        this.totalAmountText = upDigit(val)
                        this.info.amount = val
                    })
                    this.$watch('info.detailList', function (arr) {
                        let amount = 0
                        arr.forEach((v) => {
                            amount += v.amount
                        })
                        this.info.totalAmount = amount
                    })
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info.validate().then(() => {
                // 原生input弹出框校验
                if (!this.info.receiptNo) {
                    this.$Message.error('收据编号必填')
                    options.closeModal = false
                    next()
                } else if (!this.info.amount) {
                    this.$Message.error('实收金额必填')
                    options.closeModal = false
                    next()
                } else if (!this.info.payee) {
                    this.$Message.error('收款人必填')
                    options.closeModal = false
                    next()
                } else if (!this.info.payMethod) {
                    this.$Message.error('收款方式必填')
                    options.closeModal = false
                    next()
                } else {
                    // //将转换为formData的canvas图片
                    const receipt = document.getElementById('receipt')
                    html2canvas(receipt, {
                        scale: 1,
                        height: receipt.offsetHeight,
                        top: 10,
                    }).then((canvas) => {
                        //把canvas图片转成文件
                        var imgurl = canvas.toBlob((blob) => {
                            let filename = `${new Date().getTime()}.png`
                            let file2 = new File([blob], filename, {
                                type: 'image/png',
                            })
                            let formData = new FormData()
                            formData.append('files', file2)
                            //把图片文件 上传到服务器
                            fileUpload(formData)
                                .then((res) => {
                                    if (res.code == '200') {
                                        var data = res.data.list[0]
                                        //
                                        const file = {}
                                        file.id = data.id
                                        file.fileType = data.fileType
                                        file.fileName = data.fileName
                                        file.fileSize = data.fileSize
                                        file.thumbNails = data.thumbNails
                                        file.path = data.path
                                        //
                                        this.info.attachments = JSON.stringify([
                                            file,
                                        ])
                                    }
                                    var formData = deepCopy(this.info)
                                    formData.detailList.forEach((v) => {
                                        v.remark = this.info.remark
                                        v.amount = multiply(v.amount)
                                    })
                                    formData.detailList = JSON.stringify(
                                        formData.detailList
                                    )
                                    // prettier-ignore
                                    formData.totalAmount = cent(formData.totalAmount)
                                    formData.amount = cent(formData.amount)

                                    return fReceiptAdd(formData)
                                })
                                .then((res) => {
                                    this.$Message.success('开收据成功')
                                })
                                .catch((err) => {
                                    options.closeModal = false
                                })
                                .finally(() => {
                                    next()
                                })
                        })
                    })
                }
            })
        })

        // 打印
        this.$modal.onBtnClick('print', (next, options) => {
            this.$refs.receipt.print().then(() => {
                options.closeModal = false
                next()
            })
        })
    },
    methods: {
        clear() {
            this.info.houseId = ''
            this.roomList = []
        },
        fetch() {
            if (this.id) {
                return fReceiptView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        // 查询账单
        fetchBillList: debounce(500, function () {
            if (this.info.houseId && this.info.period) {
                queryReceivedBill({
                    houseId: this.info.houseId,
                    contractId: this.info.contractId,
                    period: this.info.period,
                }).then((res) => {
                    const arr = []
                    res.data.list.forEach((v) => {
                        if (v.feeType === '1') {
                            v.unit = '月'
                            v.num = this.getMonth(v.startDate, v.endDate) + ''
                        } else {
                            v.unit = ''
                            v.num = ''
                        }
                        arr.push({
                            title: this.dict.feeType.val(v.feeType), //项目
                            belongTime: `${v.startDate} 至 ${v.endDate}`, //所属时间,
                            buildArea: this.buildArea, //建筑面积,
                            unit: v.unit, //单位,
                            billId: v.id, // 账单id
                            num: v.num, //数量
                            amount: yuan(v.realAmount), //金额
                            remark: '', //备注
                        })
                    })
                    this.info.detailList = arr
                })
            } else {
                this.info.detailList = []
            }
        }),
        // 获取账期列表-合同id
        getPeriodsByContractId(contractId) {
            if (!contractId) {
                return
            }
            queryPeriods(contractId).then((res) => {
                const { cus, periods, contractId } = res.data
                const periodList = []
                if (periods?.length) {
                    periods.forEach((v) => {
                        periodList.push({
                            period: v.period,
                            text: `第${v.period}期(${v.startDate} 至 ${v.endDate})`,
                            startDate: v.startDate,
                            endDate: v.endDate,
                        })
                    })
                }
                this.periodList = periodList
                this.info.contractId = contractId
                this.info.comName = cus.comName
                this.info.cusMobile = cus.cusMobile
                if (!this.id) {
                    this.getPeriod()
                }
            })
        },
        // 获取当前账期
        getPeriod() {
            const nowDate = new Date(ymd(new Date()))
            let flag = true
            this.periodList.forEach((v) => {
                const startDate = new Date(v.startDate)
                const endDate = new Date(v.endDate)
                if (nowDate >= startDate && nowDate <= endDate) {
                    this.info.period = v.period
                    flag = false
                }
            })
            // 如果当前账期都未到时间，则获取第一期
            if (this.periodList.length && flag) {
                this.info.period = 1
            }
        },
        // 获取日期差
        getMonth(start, end) {
            const startArr = start.split('-')
            const endArr = end.split('-')
            const startMonNum =
                parseInt(startArr[0]) * 12 + parseInt(startArr[1])
            const endMonNum = parseInt(endArr[0]) * 12 + parseInt(endArr[1])
            let m = endMonNum - startMonNum
            if (endArr[2] > startArr[2]) {
                m++
            }
            return m
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    min-width: 950px;
}
</style>
